import createPersistedState from 'vuex-persistedstate'

export default ({ store }) => {
  createPersistedState({
    paths: [
      'user',
      'menu',
      // cart, minus the transient modal + loading flags
      'cart.added',
      'cart.discount',
      'cart.affiliate',
      'cart.orderId',
      'cart.cartUser',
      'cart.totals',
      'cart.status',
      'cart.serverCart',
      'cart.price_label',
      'cart.regionClicked',
      'employer',
      'geolocation',
      'jobSearch'
    ]
  })(store)

  // The stored cart can be days or months old: check it against the server once
  // per page load. Not on checkout pages, which read the order themselves and need
  // the paid order id to show the confirmation after a payment redirect.
  if (!window.location.pathname.startsWith('/checkout')) {
    store.dispatch('cart/syncCartServer')
  }
}
